import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta08 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-08/utils-consultaSeguimentoPergunta08'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta08 } from './converter-HistoricoMchatPergunta08'

interface HistoricoMChatRfPergunta08Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta08 = (props: Readonly<HistoricoMChatRfPergunta08Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta08(aplicacoes)
  if (converted == null) return null

  const { header, seInteressaPor, respondePerguntas, perguntas, respondeCriancas, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta08(model)
  const exibePerguntas = !perguntas.isEmpty()

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='8'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />
      {seInteressaPor && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[seInteressaPor]} />}
      {respondePerguntas && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[respondePerguntas]} />}
      {exibePerguntas && <HistoricoMChatSimpleVerticalTableItem pergunta='“Seu filho...”' resposta={undefined} />}
      {exibePerguntas && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />}
      {respondeCriancas && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[respondeCriancas]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
